import { Navigation } from "lucide-react";
import Reveal from "./Reveal";
import { WhatsAppIcon } from "./icons";
import { WA, SITE } from "../data/site";
import { SPACE_PHOTOS } from "../data/menu";

const OurSpace = () => (
    <section id="space" data-testid="our-space-section" className="scroll-mt-24 py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-6 md:px-12">
            <div className="grid grid-cols-1 items-start gap-16 lg:grid-cols-12">
                <div className="lg:col-span-4">
                    <Reveal>
                        <p className="eyebrow">Our Space</p>
                        <h2 className="mt-4 font-display text-4xl font-semibold tracking-tight text-saga-red sm:text-5xl">
                            Step inside Saga
                        </h2>
                        <p className="mt-6 text-base leading-relaxed text-saga-ink/70 sm:text-lg">
                            A warm, contemporary paan house on Himayatnagar Main Road — designed for lingering conversations and one
                            more paan. Come see it in person.
                        </p>
                        <div className="mt-10 flex flex-wrap items-center gap-4">
                            <a
                                href={SITE.mapsUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="our-space-directions-btn"
                                className="inline-flex items-center gap-2 rounded-full bg-saga-red px-8 py-4 text-xs font-bold uppercase tracking-[0.2em] text-saga-cream transition-colors hover:bg-saga-reddeep"
                            >
                                <Navigation className="h-4 w-4" aria-hidden="true" />
                                Get Directions
                            </a>
                            <a
                                href={WA.visit}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="our-space-whatsapp-btn"
                                className="inline-flex items-center gap-2 rounded-full border border-saga-red px-8 py-4 text-xs font-bold uppercase tracking-[0.2em] text-saga-red transition-colors hover:bg-saga-red hover:text-saga-cream"
                            >
                                <WhatsAppIcon className="h-4 w-4" />
                                Ask on WhatsApp
                            </a>
                        </div>
                    </Reveal>
                </div>
                <div className="grid grid-cols-2 gap-4 lg:col-span-8">
                    {SPACE_PHOTOS.map((photo, i) => (
                        <Reveal key={photo.src} delay={(i % 4) * 0.08}>
                            <div data-testid={`our-space-photo-${i}`} className="overflow-hidden rounded-2xl border border-saga-red/15">
                                <img
                                    src={photo.src}
                                    alt={photo.alt}
                                    loading="lazy"
                                    className="aspect-[4/3] w-full object-cover transition-transform duration-700 hover:scale-105"
                                />
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </div>
    </section>
);

export default OurSpace;
